import styled from 'styled-components';
import { StyledInputWithButtonProps } from './InputWithButton.types';

export const StyledInputWithButton = styled.form<StyledInputWithButtonProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;

  .input-with-button__button {
    cursor: pointer;

    &:disabled {
      cursor: auto;
    }
  }

  .input-with-button__input {
    &--no-outline {
      &:focus {
        outline: none;
      }
    }
  }

  ${(props) => props.customStyle}
`;
